import React from 'react';
import Link from 'next/link';
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const StartseiteCTA = () => {
  const { t } = useTranslations();
  return (
    <section className="case-studies-area pt-100 pb-100">
      <div className="container">
        <div className="section-title text-left">
          <span className="sub-title">{t('startseite_cta_title')}</span>
          <h2>{t('startseite_cta_description')}</h2>
        </div>
      </div>


      <div className="container">
        <div className="service-details-content">
          <div className="service-details">
            <div className="service-details-info ">
              <div className="large-info-box">
                <h4>{t('startseite_cta_description2')}</h4>
                <span>{t('startseite_cta_description3')}</span>
              </div>

              <div className="single-info-box">
                <h4>{t('startseite_cta_title2')}</h4>
                <ul className="social">
                  <li>
                    <a href="tel://+4943170577024" target="_blank">
                      <BiPhone />
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@simplify-data.de" target="_blank">
                      <BiEnvelope />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                      <BiLogoLinkedin />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="single-info-box">
                <Link href="/kontakt/" className="default-btn">
                  {t('startseite_cta_button')}
                </Link>
              </div>
            </div>
          </div>
        </div>

      </div>



    </section>
  );
}

export default StartseiteCTA;